module.exports = __webpack_public_path__ + "jtails-build/img/service2@1.61d875b6.jpg";